const shows_thursday = [
    {
        name: 'Dj MVurry',
        shcedule: 'Thursday 21:00',
        day: 4,
        time: 21,
        img: require('../../../img/weekly/thursday21.png')
    },
    {
        name: 'Baker',
        shcedule: 'Thursday 22:00',
        day: 4,
        time: 22,
        img: require('../../../img/weekly/thursday22.png')
    },
]

export default shows_thursday;